import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Check: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon=Check">
      <path
        id="Vector"
        d="M4 12.0002L8.94975 16.95L19.5572 6.34351"
        stroke="currentColor"
        strokeWidth="currentStrokWidth"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Check;
